import { createTextResource } from "@superwall-me/schema";
/**
 * This lets you define you're own EditorAPIContext, which is used by the
 * to override the default client.
 */ import { createContext, useContext } from "react";
const defaultFont = {
    family: "Arial",
    variants: [
        "regular"
    ],
    files: {
        regular: "arial"
    },
    kind: "system"
};
export const EditorAPIProvider = /*#__PURE__*/ createContext({
    fonts: {
        useDefaultFont: ()=>{
            return {
                fontFace: defaultFont,
                variant: "regular"
            };
        },
        useFonts: ()=>{
            return {
                Arial: defaultFont
            };
        }
    },
    products: {
        getProductReferenceNames: ()=>{
            return {
                get: ()=>{
                    return [
                        "product1",
                        "product2"
                    ];
                }
            };
        }
    },
    localization: {
        getLocalizationType: ()=>undefined,
        applyResourceToLiteral: (literal, resource)=>{
            return undefined;
        },
        useLocalization: ()=>{
            // return {
            //   status: "not-setup",
            //   setupURL: "",
            // }
            return {
                status: "ready",
                getResources: ()=>[
                        createTextResource({
                            keyId: 1234,
                            localizationProviderId: 1234,
                            isDeleted: false,
                            text: {
                                type: "property-text",
                                value: "Hello",
                                rendering: {
                                    type: "literal"
                                }
                            },
                            status: "NORMAL",
                            files: [
                                {
                                    keyName: "hello",
                                    fileId: 1234,
                                    filePath: "example.strings",
                                    isDefaultFilePath: true
                                }
                            ]
                        }, {
                            description: "Hello World",
                            organizationId: 1,
                            scope: "organization"
                        }),
                        createTextResource({
                            keyId: 1234,
                            localizationProviderId: 1234,
                            isDeleted: false,
                            text: {
                                type: "property-text",
                                value: "World",
                                rendering: {
                                    type: "literal"
                                }
                            },
                            status: "NORMAL",
                            files: [
                                {
                                    keyName: "world",
                                    fileId: 1234,
                                    filePath: "example.strings",
                                    isDefaultFilePath: true
                                }
                            ]
                        }, {
                            description: "A quick mention of the world.",
                            organizationId: 1,
                            scope: "organization"
                        })
                    ],
                openMenu: (props)=>{}
            };
        }
    },
    setHoveredNodeId: ()=>{}
});
// The provider will be created in packages/shared
export function useEditorAPI() {
    const ctx = useContext(EditorAPIProvider);
    return ctx;
}
